<!DOCTYPE html>
<html lang="en">
<head>
    <script>
        document.documentElement.classList.add('js-enabled');
        window.foucTimeout = setTimeout(function() {
            document.documentElement.classList.remove('js-enabled');
        }, 2000);
    </script>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta name="theme-color" content="#F8F9FA">
    <link rel="preload" as="font" href="fonts/Lato-Regular.woff2" type="font/woff2" crossorigin>
    <link rel="preload" as="font" href="fonts/Lato-Bold.woff2" type="font/woff2" crossorigin>
    <link rel="preload" as="font" href="fonts/Fredoka-SemiBold.woff2" type="font/woff2" crossorigin>
    <title>Our Team | Little Explorers Nursery</title>
    <link rel="icon" type="image/svg+xml" href="images/logo.svg">
    <meta name="description" content="Meet the passionate, highly-qualified team at Little Explorers Nursery.">
    <!-- 2026 AI Agent Discovery Links -->
    <link rel="alternate" type="text/plain" title="LLM Summary (Low Token)" href="/llms.txt">
    <link rel="alternate" type="text/plain" title="LLM Full Knowledge Base (High Token)" href="/llms-full.txt">
    <!-- Open Graph / Social Media -->
    <meta property="og:type" content="website">
    <meta property="og:url" content="https://littleexplorersnursery.example.com/staff">
    <meta property="og:title" content="Our Highly Qualified Childcare Team | Little Explorers Nursery">
    <meta property="og:description" content="Meet our dedicated team of Early Years educators. Fully paediatric first aid trained, delivering outstanding care in Anytown, South East Anycity.">
    <meta property="og:image" content="https://littleexplorersnursery.example.com/images/og-image.jpg">
    <meta name="twitter:card" content="summary_large_image">
    <!-- Base CSS -->
    <link rel="stylesheet" href="css/style.css">
    <!-- Staff Specific CSS -->
    <link rel="stylesheet" href="css/components/staff.css">
    <script type="module" src="js/lib/dotlottie/dotlottie-player.mjs"></script>
    
    <!-- 2026 Speculation Rules for Instant Navigation -->
    <script type="speculationrules">
    {
      "prerender": [{
        "source": "document",
        "where": {"href_matches": "/*"},
        "eagerness": "moderate"
      }]
    }
    </script>
    <script defer src="/vendor/gsap.min.js"></script>
    <script defer src="/vendor/ScrollTrigger.min.js"></script>
    <script type="module" src="/js/main.js"></script>
    <script type="module" src="/js/global-animations.js"></script>
    <script type="module" src="/js/staff.js"></script>
    <script type="application/ld+json">
    {
      "@context": "https://schema.org",
      "@type": "AboutPage",
      "mainEntity": {
        "@type": "ChildCare",
        "name": "Little Explorers Nursery",
        "founder": [
          {
            "@type": "Person",
            "name": "Jane Doe",
            "jobTitle": "Founder & Manager",
            "alumniOf": "BA (Ed) Hons Education"
          },
          {
            "@type": "Person",
            "name": "Mary Smith",
            "jobTitle": "Founder & Manager",
            "alumniOf": "BA (Hons) PGCE English"
          }
        ]
      }
    }
    </script>
</head>
<body>

    <!-- MOBILE NAVBAR START -->
    <nav class="mobile-navbar" aria-label="Mobile top bar">
        <a href="/" class="mobile-logo-link">
            <img src="images/logo.svg" alt="Little Explorers Nursery Logo" class="mobile-logo" width="45" height="44" loading="eager" fetchpriority="high">
        </a>
        <button type="button" class="mobile-menu-toggle" aria-label="Toggle navigation" aria-expanded="false">
            <span class="bar"></span>
            <span class="bar"></span>
        </button>
    </nav>

    <!-- MOBILE CURTAIN OVERLAY NAVIGATION -->
    <div class="mobile-menu-overlay" aria-hidden="true" style="display: none;">
        <nav class="mobile-overlay-nav">
            <ul class="mobile-overlay-list">
                <li><a href="/" class="mobile-overlay-link">Home</a></li>
                <li><a href="rooms" class="mobile-overlay-link">Our Rooms</a></li>
                <li><a href="staff" class="mobile-overlay-link active">Our Team</a></li>
                <li><a href="fees" class="mobile-overlay-link">Fees & Info</a></li>
                <li><a href="contact" class="mobile-overlay-link cta-pill">Book a Tour</a></li>
            </ul>
        </nav>
    </div>
    <!-- MOBILE NAVBAR END -->

    <!-- DESKTOP NAVBAR START -->
    <header class="site-header">
        <div class="container header-inner">
            <a href="/" class="logo-link">
                <img src="images/logo.svg" alt="Little Explorers Nursery Logo" class="site-logo" width="61" height="60" loading="eager" fetchpriority="high">
            </a>
            <nav class="nav-links">
                <a href="/">Home</a>
                <a href="rooms">Our Rooms</a>
                <a href="staff" class="active">Our Team</a>
                <a href="fees">Fees & Info</a>
            </nav>
            <div class="header-cta">
                <a href="contact" class="btn btn-primary">Book a Tour</a>
            </div>
        </div>
    </header>
    <!-- DESKTOP NAVBAR END -->

    <main>
        
        <!-- PAGE TITLE -->
        <section class="staff-header text-center section-padding" style="padding-bottom: 2rem;">
            <div class="container">
                <div class="section-header" style="margin-bottom: 0;">
                    <h1>Meet the 
                        <span class="crayon-wrap">
                            family
                            <!-- Highlight SVG -->
                            <svg class="crayon-svg highlight" viewBox="0 0 140 40" preserveAspectRatio="none" aria-hidden="true" focusable="false">
                                <path d="M 20,20 C 50,17 90,23 120,20" fill="none" stroke="#F6CD99" stroke-width="22" stroke-linecap="round"></path>
                            </svg>
                        </span>
                    </h1>
                    <p>Highly qualified, deeply passionate, and absolutely dedicated to your child's early years.</p>
                </div>
            </div>
        </section>

        <!-- THE FOUNDERS (2 WIDE GRID) -->
        <section class="founders-section section-padding" style="padding-top: 1rem;">
            <div class="container">
                <div class="founders-grid">
                    
                    <!-- FOUNDER 1: Jane -->
                    <div class="staff-card founder-card">
                        <div class="staff-card-img">
                            <img loading="lazy" src="images/photos/staff-jane.jpg" alt="Jane, Founder" width="800" height="600">
                        </div>
                        <div class="staff-card-content">
                            <div class="staff-card-header">
                                <h2>
                                    <span class="crayon-wrap">Jane
                                        <svg class="crayon-svg underline" viewBox="0 0 100 20" preserveAspectRatio="none" aria-hidden="true" focusable="false">
                                            <path d="M 5,15 C 30,20 70,10 95,17" fill="none" stroke="var(--color-accent)" stroke-width="4" stroke-linecap="round"></path>
                                        </svg>
                                    </span>
                                </h2>
                                <span class="role-pill primary-pill">Founder & Manager</span>
                            </div>
                            <div class="staff-qualifications">
                                <span>BA (Ed) Hons Education</span>
                                <span class="dot-divider"><span class="mask-icon icon-star"></span></span>
                                <span>Safeguarding Lead</span>
                            </div>
                            <div class="staff-quote">
                                <span class="quote-mark">"</span>
                                <p>Before founding Little Explorers Nursery, I was the Head of an Infant School and Nursery. I remain incredibly hands-on to ensure our children are always cared for by people they know and trust.</p>
                            </div>
                        </div>
                    </div>

                    <!-- FOUNDER 2: Mary -->
                    <div class="staff-card founder-card">
                        <div class="staff-card-img">
                            <img loading="lazy" src="images/photos/staff-mary.jpg" alt="Mary, Founder" width="800" height="600">
                        </div>
                        <div class="staff-card-content">
                            <div class="staff-card-header">
                                <h2>
                                    <span class="crayon-wrap">Mary
                                        <svg class="crayon-svg underline" viewBox="0 0 100 20" preserveAspectRatio="none" aria-hidden="true" focusable="false">
                                            <path d="M 5,15 C 30,20 70,10 95,17" fill="none" stroke="var(--color-accent)" stroke-width="4" stroke-linecap="round"></path>
                                        </svg>
                                    </span>
                                </h2>
                                <span class="role-pill primary-pill">Founder & Manager</span>
                            </div>
                            <div class="staff-qualifications">
                                <span>BA (Hons) PGCE English</span>
                                <span class="dot-divider"><span class="mask-icon icon-star"></span></span>
                                <span>Early Years Specialist</span>
                            </div>
                            <div class="staff-quote">
                                <span class="quote-mark">"</span>
                                <p>Jane and I have been friends for years, and I managed a large, busy nursery before we opened this one. I absolutely love working directly as the teacher in our Pre-School Room.</p>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>

        <!-- THE BREAK PARAGRAPH (ETHOS) -->
        <section class="ethos-break section-padding">
            <div class="container">
                <div class="ethos-content">
                    <h2>
                        Built by 
                        <span class="crayon-wrap">
                            families,
                            <svg class="crayon-svg underline" viewBox="0 0 100 20" preserveAspectRatio="none" aria-hidden="true" focusable="false">
                                <path d="M 5,10 C 30,15 70,5 95,12" fill="none" stroke="var(--color-accent)" stroke-width="4" stroke-linecap="round"></path>
                            </svg>
                        </span> 
                        for families.
                    </h2>
                    <p>With over two decades of combined experience in early years education, we established Little Explorers Nursery to bridge the gap between a structured educational setting and the warm, loving embrace of a family home.</p>
                    <p>We are incredibly hands-on. You won't just find us in the office; you'll find us in the mud kitchen, serving lunches, and playing alongside your little ones.</p>
                </div>
            </div>
        </section>

        <!-- THE TEAM GRID (3 WIDE) -->
        <section class="team-grid-section section-padding" style="padding-top: 0;">
            
            <div class="container" style="position: relative; z-index: 2;">
                
                <!-- BACKGROUND NURSERY MAGIC (Now safely locked inside the 1200px container!) -->
                <div class="nursery-magic-bg" aria-hidden="true" data-nosnippet>
                    <div class="background-blob blob-1"></div>
                    <div class="background-blob blob-2"></div>
                    
                    <!-- 1. Star (Left Gutter) -->
                    <svg class="floating-doodle doodle-1" viewBox="0 0 100 100" fill="none" stroke="var(--color-primary)" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><use href="images/svgs/sprites.svg#doodle-1"></use></svg>
                    
                    <!-- 3. Crescent Moon (Left Gutter) -->
                    <svg class="floating-doodle doodle-3" viewBox="-10 -10 120 120" fill="none" stroke="var(--color-accent)" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" style="overflow: visible;" aria-hidden="true" focusable="false"><use href="images/svgs/sprites.svg#doodle-3"></use></svg>

                    <!-- 5. Smiley Face (Right Gutter) -->
                    <svg class="floating-doodle doodle-5" viewBox="0 0 100 100" fill="none" aria-hidden="true" focusable="false"><use href="images/svgs/sprites.svg#doodle-5"></use></svg>

                    <!-- 7. Squiggles (Outside Left) -->
                    <svg class="floating-doodle doodle-7" viewBox="0 0 100 100" fill="none" stroke="var(--color-accent)" stroke-width="6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><use href="images/svgs/sprites.svg#doodle-7"></use></svg>

                    <!-- 9. ZigZag (Outside Right) -->
                    <svg class="floating-doodle doodle-9" viewBox="0 0 100 100" fill="none" stroke="var(--color-primary)" stroke-width="6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><use href="images/svgs/sprites.svg#doodle-9"></use></svg>

                    <!-- 11. Scribble Circle (Right Gutter) -->
                    <svg class="floating-doodle doodle-11" viewBox="0 0 100 100" fill="none" stroke="var(--color-accent)" stroke-width="6" stroke-linecap="round" aria-hidden="true" focusable="false"><use href="images/svgs/sprites.svg#doodle-11"></use></svg>

                    <!-- 13. Boxy Cat (Left Gutter) -->
                    <svg class="floating-doodle doodle-13 doodle-cat" viewBox="0 0 100 100" fill="none" stroke="var(--color-text-muted)" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><use href="images/svgs/sprites.svg#doodle-13"></use></svg>
                    
                    <!-- 15. Butterfly (Right Gutter) -->
                    <svg class="floating-doodle doodle-15 doodle-butterfly" viewBox="0 0 100 100" fill="none" stroke="var(--color-primary)" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><use href="images/svgs/sprites.svg#doodle-15"></use></svg>

                    <!-- 17. Rainbow (Outside Left) -->
                    <svg class="floating-doodle doodle-17 doodle-rainbow" viewBox="0 0 100 100" fill="none" stroke="var(--color-accent)" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><use href="images/svgs/sprites.svg#doodle-17"></use></svg>

                </div>

                <div class="team-grid">
                    
                    <!-- STAFF CARD 1 -->
                    <div class="staff-card">
                        <div class="staff-card-img">
                            <img loading="lazy" src="images/photos/placeholder-staff-14.webp" alt="Emma, Baby Room Leader" width="800" height="600">
                        </div>
                        <div class="staff-card-content">
                            <div class="staff-card-header">
                                <h2>
                                    <span class="crayon-wrap">Emma
                                        <svg class="crayon-svg underline" viewBox="0 0 100 20" preserveAspectRatio="none" aria-hidden="true" focusable="false">
                                            <path d="M 5,12 C 20,20 80,20 95,12" fill="none" stroke="var(--color-accent)" stroke-width="4" stroke-linecap="round"></path>
                                        </svg>
                                    </span>
                                </h2>
                                <span class="role-pill">Baby Cocoon Leader</span>
                            </div>
                            <div class="staff-qualifications">
                                <span>NVQ Level 3</span>
                                <span class="dot-divider"><span class="mask-icon icon-star"></span></span>
                                <span>Paediatric First Aid</span>
                            </div>
                            <div class="staff-quote">
                                <span class="quote-mark">"</span>
                                <p>Loves messy sensory play and has a magic touch for getting even the most stubborn babies down for their afternoon nap!</p>
                            </div>
                        </div>
                    </div>

                    <!-- STAFF CARD 2 -->
                    <div class="staff-card">
                        <div class="staff-card-img">
                            <img loading="lazy" src="images/photos/placeholder-staff-15.webp" alt="Chloe, Toddler Room Leader" width="800" height="600">
                        </div>
                        <div class="staff-card-content">
                            <div class="staff-card-header">
                                <h2>
                                    <span class="crayon-wrap">Chloe
                                        <svg class="crayon-svg underline" viewBox="0 0 100 20" preserveAspectRatio="none" aria-hidden="true" focusable="false">
                                            <path d="M 5,12 C 20,20 80,20 95,12" fill="none" stroke="var(--color-accent)" stroke-width="4" stroke-linecap="round"></path>
                                        </svg>
                                    </span>
                                </h2>
                                <span class="role-pill">Toddler Space Leader</span>
                            </div>
                            <div class="staff-qualifications">
                                <span>NVQ Level 4</span>
                                <span class="dot-divider"><span class="mask-icon icon-star"></span></span>
                                <span>SENCO Certified</span>
                            </div>
                            <div class="staff-quote">
                                <span class="quote-mark">"</span>
                                <p>Our resident storyteller. She knows every single word to The Gruffalo and does all the voices perfectly.</p>
                            </div>
                        </div>
                    </div>

                    <!-- STAFF CARD 3 -->
                    <div class="staff-card">
                        <div class="staff-card-img">
                            <img loading="lazy" src="images/photos/placeholder-staff-16.webp" alt="Our Resident Artist" width="800" height="600">
                        </div>
                        <div class="staff-card-content">
                            <div class="staff-card-header">
                                <h2>
                                    <span class="crayon-wrap">Resident Artist
                                        <svg class="crayon-svg underline" viewBox="0 0 100 20" preserveAspectRatio="none" aria-hidden="true" focusable="false">
                                            <path d="M 5,12 C 20,20 80,20 95,12" fill="none" stroke="var(--color-accent)" stroke-width="4" stroke-linecap="round"></path>
                                        </svg>
                                    </span>
                                </h2>
                                <span class="role-pill">Creative Lead</span>
                            </div>
                            <div class="staff-qualifications">
                                <span>Qualified EY Teacher</span>
                                <span class="dot-divider"><span class="mask-icon icon-star"></span></span>
                                <span>Art Therapy</span>
                            </div>
                            <div class="staff-quote">
                                <span class="quote-mark">"</span>
                                <p>As a qualified early years teacher, I love providing a very special introduction to creative activities. Together, the children and I design stunning nature mosaics for the garden.</p>
                            </div>
                        </div>
                    </div>

                    <!-- STAFF CARD 4 -->
                    <div class="staff-card">
                        <div class="staff-card-img">
                            <img loading="lazy" src="images/photos/placeholder-staff-17.webp" alt="Music Specialist" width="800" height="600">
                        </div>
                        <div class="staff-card-content">
                            <div class="staff-card-header">
                                <h2>
                                    <span class="crayon-wrap">Music Specialist
                                        <svg class="crayon-svg underline" viewBox="0 0 100 20" preserveAspectRatio="none" aria-hidden="true" focusable="false">
                                            <path d="M 5,12 C 20,20 80,20 95,12" fill="none" stroke="var(--color-accent)" stroke-width="4" stroke-linecap="round"></path>
                                        </svg>
                                    </span>
                                </h2>
                                <span class="role-pill">Performing Arts Lead</span>
                            </div>
                            <div class="staff-qualifications">
                                <span>Music Theory</span>
                                <span class="dot-divider"><span class="mask-icon icon-star"></span></span>
                                <span>Drama Specialist</span>
                            </div>
                            <div class="staff-quote">
                                <span class="quote-mark">"</span>
                                <p>My goal is to develop the children's concentration through drama and rhythm. It's so rewarding to help them set traditional tales from around the world to music!</p>
                            </div>
                        </div>
                    </div>

                    <!-- STAFF CARD 5 (Sophie - Yoga) -->
                    <div class="staff-card">
                        <div class="staff-card-img">
                            <img loading="lazy" src="images/photos/placeholder-staff-18.webp" alt="Sophie, Yoga Instructor" width="800" height="600">
                        </div>
                        <div class="staff-card-content">
                            <div class="staff-card-header">
                                <h2>
                                    <span class="crayon-wrap">Sophie
                                        <svg class="crayon-svg underline" viewBox="0 0 100 20" preserveAspectRatio="none" aria-hidden="true" focusable="false">
                                            <path d="M 5,12 C 20,20 80,20 95,12" fill="none" stroke="var(--color-accent)" stroke-width="4" stroke-linecap="round"></path>
                                        </svg>
                                    </span>
                                </h2>
                                <span class="role-pill">Visiting Yoga Instructor</span>
                            </div>
                            <div class="staff-qualifications">
                                <span>Certified Kids Yoga</span>
                                <span class="dot-divider"><span class="mask-icon icon-star"></span></span>
                                <span>Mindfulness Coach</span>
                            </div>
                            <div class="staff-quote">
                                <span class="quote-mark">"</span>
                                <p>I run the weekly Yoga sessions here at the nursery. The children always get completely stuck in, and it's wonderful teaching them how to stretch, breathe, and relax.</p>
                            </div>
                        </div>
                    </div>

                    <!-- STAFF CARD 6 (Sam - Admin) -->
                    <div class="staff-card">
                        <div class="staff-card-img">
                            <img loading="lazy" src="images/photos/placeholder-staff-19.webp" alt="Sam, Admin" width="800" height="600">
                        </div>
                        <div class="staff-card-content">
                            <div class="staff-card-header">
                                <h2>
                                    <span class="crayon-wrap">Sam
                                        <svg class="crayon-svg underline" viewBox="0 0 100 20" preserveAspectRatio="none" aria-hidden="true" focusable="false">
                                            <path d="M 5,12 C 20,20 80,20 95,12" fill="none" stroke="var(--color-accent)" stroke-width="4" stroke-linecap="round"></path>
                                        </svg>
                                    </span>
                                </h2>
                                <span class="role-pill">Nursery Administrator</span>
                            </div>
                            <div class="staff-qualifications">
                                <span>Policy Management</span>
                                <span class="dot-divider"><span class="mask-icon icon-star"></span></span>
                                <span>Health & Safety Lead</span>
                            </div>
                            <div class="staff-quote">
                                <span class="quote-mark">"</span>
                                <p>I'm the organizational heart of the nursery! I make sure all our policies, funding documentation, and daily safety procedures run perfectly behind the scenes.</p>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>

        <!-- PRE-FOOTER CTA -->
        <section class="pre-footer section-padding text-center">
            <div class="container">
                
                <!-- Floating Background Lottie (Moved inside 1200px container) -->
                <div class="decor-lottie book-bg" aria-hidden="true" data-nosnippet>
                    <dotlottie-player src="images/animations/book.lottie" autoplay loop></dotlottie-player>
                </div>

                <h2>Come and meet us</h2>
                <p>We would love to show you around our beautiful spaces and answer any questions you have about your child's early years journey.</p>
                <a href="contact" class="btn btn-primary btn-large">Book a Personal Tour</a>
            </div>
        </section>

        <!-- FOOTER (Matches existing pages) -->
        <footer class="site-footer">
            <div class="container">
                <div class="footer-grid">
                    <div class="footer-col brand-col">
                        <h3 class="footer-logo-text"><span translate="no">Little Explorers Nursery</span></h3>
                        <p>A nurturing, home-from-home early years setting in the heart of Anytown, Anycity.</p>
                        <div class="footer-badges">
                            <a href="https://ratings.food.gov.uk/" target="_blank" rel="noopener noreferrer">
                                <img loading="lazy" src="images/svgs/fhrs-badge-5.svg" alt="Food Hygiene Rating 5" class="footer-badge-img" width="160" height="80">
                            </a>
                            <a href="https://reports.ofsted.gov.uk/" target="_blank" rel="noopener noreferrer" aria-label="Read our Ofsted Report">
                                <img loading="lazy" src="images/svgs/Ofsted_Good_GP_White.svg" alt="Ofsted Good Provider" class="ofsted-footer-badge" width="60" height="60">
                            </a>
                        </div>
                    </div>
                    <div class="footer-col links-col">
                        <h4>Explore</h4>
                        <ul>
                            <li><a href="/">Home</a></li>
                            <li><a href="rooms">Our Rooms</a></li>
                            <li><a href="staff">Our Team</a></li>
                            <li><a href="fees">Fees & Funding</a></li>
                            <li><a href="contact">Contact</a></li>
                        </ul>
                    </div>
                    <div class="footer-col contact-col">
                        <h4>Get in Touch</h4>
                        <address>
                            <ul>
                                <li><strong>A:</strong> <a href="https://maps.google.com/?q=13+Anytown+Green,+Anycity+AT1+5LB" target="_blank" rel="noopener noreferrer">13 Anytown Green, Anycity AT1 5LB</a></li>
                                <li><strong>T:</strong> <a href="tel:+442079460123">020 7946 0123</a></li> 
                                <li><strong>E:</strong> <a href="mailto:hello@littleexplorersnursery.example.com">hello@littleexplorersnursery.example.com</a></li>
                            </ul>
                        </address>
                        <h4 class="hours-title">Opening Hours</h4>
                        <p class="hours-text"><span>Mon - Fri: 8:00am - 6:00pm</span><span>Sat - Sun: Closed</span></p>
                    </div>
                </div>
                <div class="footer-bottom">
                    <p>&copy; <span id="current-year"></span> All Rights Reserved - <a href="https://selcreative.co.uk/" target="_blank" rel="noopener noreferrer">SEL Creative</a></p>
                    <div class="legal-links">
                        <a href="privacy">Privacy Policy</a>
                        <span class="divider">|</span>
                        <a href="safeguarding">Safeguarding Policy</a>
                    </div>
                </div>
            </div>
        </footer>
    </main>

</body>
</html>
